import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import _ from "lodash";
import React from "react";
import { Button, Checkbox } from "react-bootstrap";
import autoBind from "react-autobind";

import { setFilterGenreProperty, setFilterTagProperty, setShowDependencies, setShowVisible, setFilterSetting } from "../../actions/inventoryActions";
import * as utils from "../../utils/utils.js";

const FILTERS_COLLAPSED_STORAGE_KEY_PREFIX = "ambifi.nav.filtersCollapsed";

class NavItemMyChecklists extends React.Component {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	componentDidMount() {
		this.restoreFiltersCollapsedSetting();
	}

	componentDidUpdate(prevProps) {
		if (this.getFiltersCollapsedStorageKey(prevProps) !== this.getFiltersCollapsedStorageKey()) {
			this.restoreFiltersCollapsedSetting();
		}
	}

	getFiltersCollapsedStorageKey(props = this.props) {
		const username = _.get(props, ["user", "username"], "anonymous") || "anonymous";
		const orgId = _.get(props, ["selectedOrg", "id"], "global") || "global";
		return `${FILTERS_COLLAPSED_STORAGE_KEY_PREFIX}.${username}.${orgId}`;
	}

	restoreFiltersCollapsedSetting() {
		const storedValue = utils.getLs(this.getFiltersCollapsedStorageKey());
		if (storedValue === true || storedValue === "true") {
			setFilterSetting("filtersCollapsed", true);
		} else if (storedValue === false || storedValue === "false") {
			setFilterSetting("filtersCollapsed", false);
		} else {
			setFilterSetting("filtersCollapsed", true);
		}
	}

	areFiltersCollapsed() {
		return !!(this.props.filterSettings && this.props.filterSettings.filtersCollapsed);
	}

	handleToggleFiltersCollapsed(e) {
		if (e && e.stopPropagation) {
			e.stopPropagation();
		}
		const nextValue = !this.areFiltersCollapsed();
		setFilterSetting("filtersCollapsed", nextValue);
		utils.setLs(this.getFiltersCollapsedStorageKey(), nextValue);
	}

	handleExpandGenres() {
		setFilterSetting("expandGenres", true);
	}

	handleCollapseGenres() {
		setFilterSetting("expandGenres", false);
	}

	handleExpandTags() {
		setFilterSetting("expandTags", true);
	}

	handleCollapseTags() {
		setFilterSetting("expandTags", false);
	}

	handleSortGenresByCount() {
		setFilterSetting("sortGenresByCount", true);
	}

	handleSortGenresByName() {
		setFilterSetting("sortGenresByCount", false);
	}

	handleSortTagsByCount() {
		setFilterSetting("sortTagsByCount", true);
	}

	handleSortTagsByName() {
		setFilterSetting("sortTagsByCount", false);
	}

	handleClearFilters() {
		this.props.filtersAll.genres.forEach((genre) => {
			setFilterGenreProperty(this.context.tree, genre.genre, false, this.props.onFilter, this.props.onFilterEnd);
		});
		this.props.filtersAll.tags.forEach((tag) => {
			setFilterTagProperty(this.context.tree, tag.tag, false, this.props.onFilter, this.props.onFilterEnd);
		});
	}

	getNormalizedTagSortValue(tag) {
		if (!tag || !tag.tag) {
			return "";
		}
		return String(tag.tag).toLocaleLowerCase();
	}

	getActiveFilterCount() {
		const filtersAll = this.props.filtersAll || {};
		const genres = _.isArray(filtersAll.genres) ? filtersAll.genres : [];
		const tags = _.isArray(filtersAll.tags) ? filtersAll.tags : [];
		let count = genres.filter((genre) => genre && genre.checked).length + tags.filter((tag) => tag && tag.checked).length;
		if (!this.props.showVisible) {
			count += 1;
		}
		if (!this.props.showDependencies) {
			count += 1;
		}
		return count;
	}

	render() {
		let self = this;

		let clearFilters =
			<Button bsStyle="link" style={{ margin: 0, padding: "5px", marginLeft: "-5px", marginBottom: "10px" }} onClick={this.handleClearFilters} key={"clear-filters"}>Clear Filters</Button>;

		let genresTitle;


		let expandTags = false;
		let expandGenres = false;
		const { filterSettings } = this.props;
		if (filterSettings) {
			if (filterSettings.expandTags) {
				expandTags = filterSettings.expandTags;
			}
			if (filterSettings.expandGenres) {
				expandGenres = filterSettings.expandGenres;
			}
		}

		let genres = [];

		if (filterSettings.sortGenresByCount) {
			_.reverse(_.sortBy(this.props.filtersAll.genres, ["count", "genre"])).forEach((genre, i) => {
				if ((!expandGenres && i <= 9) || expandGenres) {
					let genreIcon = utils.getGenreIconForType(self.context.tree, genre.genre);

					if (genre.count > 0) {
						genres.push(<div key={"genre" + i}>
							<Checkbox checked={genre.checked} onChange={(e) => { setFilterGenreProperty(self.context.tree, genre.genre, e.target.checked, self.props.onFilter, self.props.onFilterEnd); }}>
								<FontAwesomeIcon fixedWidth={true} style={{ fontSize: "16px" }} icon={genreIcon} /> {genre.genre} ({genre.count})
							</Checkbox>
						</div>);
					}
				}
			});
		} else {
			_.sortBy(this.props.filtersAll.genres, ["genre"]).forEach((genre, i) => {
				if ((!expandGenres && i <= 9) || expandGenres) {
					let genreIcon = utils.getGenreIconForType(self.context.tree, genre.genre);
					if (genre.count > 0) {
						genres.push(<div key={"genre" + i}>
							<Checkbox checked={genre.checked} onChange={(e) => { setFilterGenreProperty(self.context.tree, genre.genre, e.target.checked, self.props.onFilter, self.props.onFilterEnd); }}>
								<FontAwesomeIcon fixedWidth={true} style={{ fontSize: "16px" }} icon={genreIcon} /> {genre.genre} ({genre.count})
							</Checkbox>
						</div>);
					}
				}
			});
		}
		if (this.props.filtersAll.genres.length > 10) {
			if (!expandGenres) {
				genres.push(<Button bsStyle="link" onClick={this.handleExpandGenres} key={"genre-expand"}>Show More...</Button>);
			} else {
				genres.push(<Button bsStyle="link" onClick={this.handleCollapseGenres} key={"genre-collapse"}>Show Less...</Button>);
			}
		}


		if (genres.length !== 0) {
			genresTitle =
				<div>
					<b>Genres</b>
					{this.props.filterSettings.sortGenresByCount &&
						<Button bsStyle="link" bsSize="xsmall" style={{ fontSize: "10px" }} onClick={this.handleSortGenresByName} key={"genre-sort-by-name"}>Sort By Name</Button>
					}
					{!this.props.filterSettings.sortGenresByCount &&
						<Button bsStyle="link" bsSize="xsmall" style={{ fontSize: "10px" }} onClick={this.handleSortGenresByCount} key={"genre-sort-by-count"}>Sort By Count</Button>
					}
					<br />
				</div>;
		}

		let tagsTitle;
		// _.sortBy(users, ['user', 'age']);


		let tags = [];
		if (filterSettings.sortTagsByCount) {
			_.reverse(_.sortBy(this.props.filtersAll.tags, ["count", (tag) => this.getNormalizedTagSortValue(tag), "tag"])).forEach((tag, i) => {
				if ((!expandTags && i <= 9) || expandTags) {
					if (tag.count > 0) {
						tags.push(<div key={"tag" + i}>
							<Checkbox checked={tag.checked} onChange={(e) => { setFilterTagProperty(self.context.tree, tag.tag, e.target.checked, self.props.onFilter, self.props.onFilterEnd); }}>
								{tag.tag} ({tag.count})
							</Checkbox>
						</div>);
					}
				}
			});
		} else {
			_.sortBy(this.props.filtersAll.tags, [(tag) => this.getNormalizedTagSortValue(tag), "tag"]).forEach((tag, i) => {
				if ((!expandTags && i <= 9) || expandTags) {
					if (tag.count > 0) {
						tags.push(<div key={"tag" + i}>
							<Checkbox checked={tag.checked} onChange={(e) => { setFilterTagProperty(self.context.tree, tag.tag, e.target.checked, self.props.onFilter, self.props.onFilterEnd); }}>
								{tag.tag} ({tag.count})
							</Checkbox>
						</div>);
					}
				}
			});
		}


		if (this.props.filtersAll.tags.length > 10) {
			if (!expandTags) {
				tags.push(<Button bsStyle="link" onClick={this.handleExpandTags} key={"tags-expand"}>Show More...</Button>);
			} else {
				tags.push(<Button bsStyle="link" onClick={this.handleCollapseTags} key={"tags-collapse"}>Show Less...</Button>);
			}
		}
		if (tags.length !== 0) {
			tagsTitle =
				<div>
					<b>Tags</b>
					{this.props.filterSettings.sortTagsByCount &&
						<Button bsStyle="link" bsSize="xsmall" style={{ fontSize: "10px" }} onClick={this.handleSortTagsByName} key={"tags-sort-by-name"}>Sort By Name</Button>
					}
					{!this.props.filterSettings.sortTagsByCount &&
						<Button bsStyle="link" bsSize="xsmall" style={{ fontSize: "10px" }} onClick={this.handleSortTagsByCount} key={"tags-sort-by-count"}>Sort By Count</Button>
					}
					<br />
				</div>;
		}

		let showVisible =
			<Checkbox checked={!this.props.showVisible} onChange={(e) => { setShowVisible(self.context.tree, !e.target.checked, self.props.onFilter, self.props.onFilterEnd); }}>
				Show Visible Only
			</Checkbox>;
		let showDependencies =
			<Checkbox checked={this.props.showDependencies} onChange={(e) => { setShowDependencies(self.context.tree, e.target.checked, self.props.onFilter, self.props.onFilterEnd); }}>
				Show Dependencies
			</Checkbox>;
		const filtersCollapsed = this.areFiltersCollapsed();
		const activeFilterCount = this.getActiveFilterCount();
		const filterToggleLabel = filtersCollapsed ? "Show filters" : "Hide filters";
		const filterSummary = activeFilterCount > 0 ? `${activeFilterCount} active` : "No active filters";
		const filtersHeader = (
			<div className="ambifiNavFiltersHeader">
				<div>
					<div className="ambifiNavFiltersTitle">Filters</div>
					<div className="ambifiNavFiltersSummary">{filterSummary}</div>
				</div>
				<Button
					aria-label={filterToggleLabel}
					bsStyle="link"
					className="ambifiNavFiltersToggle"
					onClick={this.handleToggleFiltersCollapsed}
					title={filterToggleLabel}
					type="button"
				>
					<FontAwesomeIcon icon={filtersCollapsed ? "chevron-down" : "chevron-up"} />
				</Button>
			</div>
		);

		let genresPanel;
		if (this.props.capabilitiesMyChecklists.filterGenresVisible) {
			genresPanel =
				<div>
					{genresTitle}
					{genres}
				</div>;

		}

		let filters;
		if (this.props.selected && (this.props.filtersAll.genres.length > 0 || this.props.filtersAll.tags.length > 0)) {
			filters = (this.props.visibilityOnly) ? null : (
				<div className="ambifiNavFilters" onClick={(e) => e.stopPropagation()}>
					{filtersHeader}
					{!filtersCollapsed &&
						<div className="ambifiNavFiltersBody">
							{showVisible}
							{showDependencies}
							<hr />
							{clearFilters}
							{genresPanel}
							<div>
								{tagsTitle}
								{tags}
							</div>
						</div>
					}
				</div>);
		}

		return (
			<div className={`ambifiNavItem ambifiNavItemWithFilters ${this.props.selected ? "ambifiNavItemSelected" : ""}`} onClick={this.props.onClick}>
				<div className="ambifiNavItemContent">
					<div className="ambifiNavItemHeader">
						<FontAwesomeIcon fixedWidth={true} className="ambifiNavItemIcon" icon={this.props.icon} />
						<span>{this.props.label}</span>
					</div>
					{filters}
				</div>
			</div>
		);
	}
}

NavItemMyChecklists.contextTypes = {
	tree: PropTypes.baobab
};


export default branch({
	showVisible: ["appState", "filters", "showVisible"],
	filterSettings: ["appState", "filters", "settings"],
	showDependencies: ["appState", "filters", "showDependencies"],
	capabilitiesMyChecklists: ["appCapabilities", "views", "myChecklists"],
	selectedOrg: ["selectedOrg"],
	user: ["user"]
}, NavItemMyChecklists);
